export default __webpack_public_path__ + "static/media/Truly_Logo_Dark.5f0daaf2.png";